import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/customer-profiles',
    name: 'customer-profile',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/customer-profile/index.vue')
  },
  {
    path: '/customer-profiles/create',
    name: 'customer-profile-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/customer-profile/create.vue')
  },
  {
    path: '/customer-profiles/:id',
    name: 'customer-profile-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/customer-profile/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
